import {
  Box,
  Button,
  Checkbox,
  Grid,
  TextField,
  Typography,
  Link,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";
import { useRef, useState } from "react";
import backgroundContacto from "../../assets/images/fotoContacto.png";
import { useTranslation } from "react-i18next";

const Contacto = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const formRef = useRef(null);
  const [acepta, setAcepta] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!acepta) {
      alert("Debes aceptar el uso de tus datos para continuar.");
      return;
    }

    setEnviando(true);
    const formData = new FormData(formRef.current);

    try {
      const response = await fetch("https://usebasin.com/f/24866888331b", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("Formulario enviado correctamente.");
        formRef.current.reset();
        setAcepta(false);
      } else {
        alert("Error al enviar. Por favor, intentá nuevamente.");
      }
    } catch (err) {
      console.error(err);
      alert("Error de red.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "90vdh",
        position: "relative",
        overflow: "hidden",
        boxShadow: 3,
        backgroundImage: `url(${backgroundContacto})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        py: 4,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={5} alignItems="flex-start">
          {/* Columna del formulario */}
          <Grid item xs={12} md={7}>
            <Box textAlign={isMobile ? "left" : "left"} mb={4}>
              <Typography
                sx={{
                  color: "#6EB1D9",
                  fontFamily: "Montserrat",
                  fontSize: "1.65rem", // más relativo
                  fontWeight: 800,
                  lineHeight: 1.1,
                  mb: 1,
                }}
              >
                {t("contacto")}
              </Typography>

              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "2.66rem",
                  fontWeight: 800,
                  lineHeight: 1,
                  mb: 2,
                }}
              >
                {t("contacto_titulo")}
              </Typography>

              <Typography
                sx={{
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "1.3rem",
                  fontWeight: 500,
                  lineHeight: 1.2,
                  letterSpacing: "-0.133px",
                }}
              >
                {t("contacto_pregunta")}
              </Typography>
            </Box>

            {/* Formulario */}
            <Box
              sx={{
                width: "100%",
                borderRadius: "20px",
                background: "#FFF",
                py: 5,
                px: { xs: 4, md: 6 },
                boxShadow: 3,
              }}
            >
              <form ref={formRef} onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  {[
                    { label: t("nombre_y_apellido"), name: "nombre", size: 12 },
                    { label: t("empresa"), name: "empresa", size: 12 },
                    { label: t("pais"), name: "pais", size: 6 },
                    { label: t("ciudad"), name: "ciudad", size: 6 },
                    { label: t("email"), name: "email", size: 6 },
                    { label: t("telefono"), name: "telefono", size: 6 },
                  ].map((field, index) => (
                    <Grid item xs={12} sm={field.size} key={index}>
                      <TextField
                        name={field.name}
                        fullWidth
                        label={field.label}
                        variant="outlined"
                        required
                        sx={{
                          input: { color: "#1B2466" },
                          "& .MuiInputLabel-root": { color: "#979797" },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#1B2466",
                              borderRadius: "14px",
                            },
                            "&:hover fieldset": { borderColor: "#1B2466" },
                            "&.Mui-focused fieldset": { borderColor: "#1B2466" },
                          },
                        }}
                      />
                    </Grid>
                  ))}

                  <Grid item xs={12}>
                    <TextField
                      name="mensaje"
                      fullWidth
                      label={t("mensaje")}
                      multiline
                      rows={4}
                      variant="outlined"
                      required
                      sx={{
                        textarea: { color: "#1B2466" },
                        "& .MuiInputLabel-root": { color: "#979797" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#1B2466",
                            borderRadius: "14px",
                          },
                          "&:hover fieldset": { borderColor: "#1B2466" },
                          "&.Mui-focused fieldset": { borderColor: "#1B2466" },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      flexDirection="row" // siempre en fila
                      alignItems="center" // centra verticalmente
                      sx={{ mt: 2 }}
                    >
                      <Checkbox
                        checked={acepta}
                        onChange={(e) => setAcepta(e.target.checked)}
                        sx={{
                          color: "#1B2466",
                          "&.Mui-checked": { color: "#1B2466" },
                          transform: "scale(1.3)",
                          mr: 1, // margen a la derecha
                        }}
                      />
                      <Typography
                        sx={{
                          color: "#979797",
                          fontFamily: "Montserrat",
                          fontSize: { xs: "14px", sm: "16px" },
                          fontWeight: "400",
                          lineHeight: "120%",
                        }}
                      >
                        {t("terminos_condiciones")}
                      </Typography>
                    </Box>
                  </Grid>


                  <Grid item xs={12}>
                    <Box sx={{ pt: 2, textAlign: { xs: "center", sm: "left" } }}>
                      <Button
                        type="submit"
                        disabled={enviando}
                        sx={{
                          borderRadius: "15px",
                          background: "#1B2466",
                          px: 4,
                          py: 1.5,
                          "&:hover": {
                            background: "#2a3a8c",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#FFF",
                            fontFamily: "Montserrat",
                            fontSize: "16px",
                            fontWeight: "500",
                            textTransform: "none",
                          }}
                        >
                          {enviando ? t("enviando") : t("enviar")}
                        </Typography>
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>

          {/* Columna de información de contacto - Alineada con el formulario */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                pl: { md: 4 },
                marginLeft: 4,
                // Aseguramos que comience desde la parte superior del contenedor
                marginTop: { xs: 4, md: 25 }, // Ajuste para alinear con el formulario
              }}
            >
              {/* EMA Electromecanica S.A. */}
              <Box>
                <Typography
                  sx={{
                    color: "white",
                    fontFamily: "Montserrat",
                    fontSize: "26px",
                    fontWeight: 700,
                    lineHeight: "130%",
                    mb: 2,
                  }}
                >
                  EMA Electromecanica S.A.
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      color: "white",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "150%",
                      mb: 1,
                    }}
                  >
                    Av. San Martin 4970 B1604CDX Florida, Buenos Aires, Argentina
                  </Typography>
                  <Typography
                    sx={{
                      color: "white",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "150%",
                      mb: 1,
                    }}
                  >
                    Tel: +54 11 4760-0054 / +54 11 4760-0052
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 0.5,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Mail:
                    </Typography>
                    <Link
                      href="mailto:contacto@ema.com.ar"
                      sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 500,
                        textDecoration: "underline",
                      }}
                    >
                      contacto@ema.com.ar
                    </Link>
                    <Typography
                      sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      /
                    </Typography>
                    <Link
                      href="mailto:gcom@ema.com.ar"
                      sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 500,
                        textDecoration: "underline",
                      }}
                    >
                      gcom@ema.com.ar
                    </Link>
                  </Box>
                </Box>
              </Box>

              {/* EMA Electromechanics INC */}
              <Box>
                <Typography
                  sx={{
                    color: "white",
                    fontFamily: "Montserrat",
                    fontSize: "26px",
                    fontWeight: 700,
                    lineHeight: "130%",
                    mb: 2,
                  }}
                >
                  EMA Electromechanics INC
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      color: "white",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "150%",
                      mb: 1,
                    }}
                  >
                    16 Industrial St, Sweetwater, TX 79556
                  </Typography>
                  <Typography
                    sx={{
                      color: "white",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "150%",
                      mb: 1,
                    }}
                  >
                    Tel: (325) 235-8000
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Mail:
                    </Typography>
                    <Link
                      href="mailto:contact@emaelectromechanics.com"
                      sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 500,
                        textDecoration: "underline",
                      }}
                    >
                      contact@emaelectromechanics.com
                    </Link>
                  </Box>
                </Box>
              </Box>

              {/* EMA Servicios S.A. */}
              <Box>
                <Typography
                  sx={{
                    color: "white",
                    fontFamily: "Montserrat",
                    fontSize: "26px",
                    fontWeight: 700,
                    lineHeight: "130%",
                    mb: 2,
                  }}
                >
                  EMA Servicios S.A.
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      color: "white",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "150%",
                      mb: 1,
                    }}
                  >
                    Av. San Martin 4970 B1604CDX Florida, Buenos Aires, Argentina
                  </Typography>
                  <Typography
                    sx={{
                      color: "white",
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "150%",
                      mb: 1,
                    }}
                  >
                    Tel: (011) 4730-1902
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography
                      sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Mail:
                    </Typography>
                    <Link
                      href="mailto:info@emaservicios.com.ar"
                      sx={{
                        color: "white",
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: 500,
                        textDecoration: "underline",
                      }}
                    >
                      info@emaservicios.com.ar
                    </Link>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contacto;